import Case from 'case';

import { CreatedEvent, EcommerceFlightItem, PointsValue } from '../../../types';

export type FlightViewItemListEvenProps = {
  items: EcommerceFlightItem[];
  paymentType: PointsValue;
  travelDetails: {
    origin?: string | null;
    destination?: string | null;
    duration?: number;
    departureDate?: string;
    returnDate?: string;
  };
  travellers?: {
    adults?: number;
    children?: number;
    infants?: number;
  };
};

export const createFlightViewItemListEvent = ({
  items,
  paymentType,
  travelDetails,
  travellers,
}: FlightViewItemListEvenProps): CreatedEvent => {
  const postSearchData = {
    start_date: travelDetails.departureDate,
    end_date: travelDetails.returnDate,
    duration: travelDetails.duration,
    travellers_adult: travellers?.adults,
    travellers_children: travellers?.children,
    travellers_infant: travellers?.infants,
  };

  const name = `${items[0].flight_type} flight options`.toLowerCase();

  return {
    eventInfo: {
      event: 'view_item_list',
      event_data: {
        action: 'view',
        component_type: 'item_list',
        search_payment_toggle: paymentType,
        available_package_count: items.length,
        destination: travelDetails.destination,
        search_type: 'list',
        origin: travelDetails.origin,
        page_type: 'flight options',
        flight_type: items[0]?.flight_type,
        international_or_domestic: items[0]?.international_or_domestic,
        ...postSearchData,
      },
      ecommerce: {
        currency: 'AUD',
        item_list_id: Case.snake(name),
        item_list_name: name,
        items,
      },
    },
    eventOptions: {
      debugMessage: 'GA4 Data Layer Event (Flight View Item List)',
    },
  };
};
